import React from "react";
import { Drawer } from "@mui/material";
import DrawerContent from "./DrawerContent";

const drawerWidth = 240;

const drawerStyles = {
  boxSizing: 'border-box',
  width: drawerWidth,
  backgroundColor: '#252526',
  color: '#d4d4d4'
};

export default function Navigation({ mobileOpen, onDrawerToggle }) {
  return (
    <>
      {/* Mobile Drawer */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={onDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': drawerStyles,
        }}
      >
        <DrawerContent onMenuItemClick={onDrawerToggle} />
      </Drawer>

      {/* Desktop Drawer */}
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: 'none', md: 'block' },
          '& .MuiDrawer-paper': drawerStyles,
        }}
        open
      >
        <DrawerContent onMenuItemClick={() => {}} />
      </Drawer>
    </>
  );
}
